import {
  faChartSimple,
  faHome,
  faRectangleHistory,
  faSearch,
  faUser,
} from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import {
  faChartSimple as faChartSimpleSolid,
  faHome as faHomeSolid,
  faRectangleHistory as faRectangleHistorySolid,
  faSearch as faSearchSolid,
  faUser as faUserSolid,
} from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import type { Pathname } from '@components/main-components/link/AccessibleLink';
import { NAV_LINKS } from '@utils/constants';

export type ActiveSectionList = 'HOME' | 'FEED' | 'EXPLORE' | 'CHARTS' | 'SIGNIN' | 'PROFILE';

export const MOBILE_NAV_LINKS = {
  HOME: {
    activeIcon: faHomeSolid,
    inactiveIcon: faHome,
    label: 'Home',
    pathname: NAV_LINKS.Home as Pathname,
  },
  FEED: {
    activeIcon: faRectangleHistorySolid,
    inactiveIcon: faRectangleHistory,
    label: 'Feed',
    pathname: NAV_LINKS.Feed as Pathname,
  },
  EXPLORE: {
    activeIcon: faSearchSolid,
    inactiveIcon: faSearch,
    label: 'Search',
    pathname: NAV_LINKS.Explore as Pathname,
  },
  CHARTS: {
    activeIcon: faChartSimpleSolid,
    inactiveIcon: faChartSimple,
    label: 'Charts',
    pathname: NAV_LINKS.ViralChartsSounds as Pathname,
  },
  PROFILE: {
    label: 'Profile',
    pathname: undefined,
  },
  SIGNIN: {
    activeIcon: faUserSolid,
    inactiveIcon: faUser,
    label: 'Sign In',
    pathname: NAV_LINKS.SignIn as Pathname,
  },
};
